<template>
  <div class="container">
    <Breadcrumbs :items="breadcrumbs" />
    <h1 class="sr-only">Registrati</h1>
    <section class="py-14 md:py-16 max-w-modal mx-auto">
      <MessageBox
        v-if="
          requestSent ||
          ($store.state.auth.loggedIn && !$store.state.auth.user.finalized)
        "
        :show="true"
        icon="mail-sent"
        size="lg"
      >
        <p class="text-center">
          Ci sei quasi, controlla la mail!<br aria-hidden="true" />
          Abbiamo inviato una mail all'indirizzo
          <strong>{{ email }}</strong>
          <br aria-hidden="true" />Per completare la registrazione ti basta
          <strong>cliccare sul link ricevuto nella mail</strong> e potrai subito
          accedere alla tua area riservata!
        </p>
      </MessageBox>
      <UcrsTabs
        v-show="!requestSent && !$store.state.auth.loggedIn"
        v-model="activeTab"
      >
        <UcrsTabItem key="0" value="0" label="Accedi al tuo account">
          <FormLogin
            :show-register="false"
            class="my-24 m-auto"
            @success="handleLogin"
          />
        </UcrsTabItem>
        <UcrsTabItem key="1" value="1" label="Registrati">
          <p class="text-center pb-12">
            Ci vogliono solo pochi secondi per creare il tuo account.
          </p>
          <FormRegister @success="handleSuccess" />
        </UcrsTabItem>
      </UcrsTabs>
    </section>
  </div>
</template>
<script>
import Breadcrumbs from '~/components/Breadcrumbs.vue'
import FormLogin from '~/components/FormLogin.vue'
import FormRegister from '~/components/FormRegister.vue'
import MessageBox from '~/components/MessageBox.vue'
import UcrsTabs from '~/components/UcrsTabs.vue'
import UcrsTabItem from '~/components/UcrsTabItem'

export default {
  components: {
    Breadcrumbs,
    FormLogin,
    FormRegister,
    MessageBox,
    UcrsTabs,
    UcrsTabItem,
  },
  middleware: ['finalized'],
  data() {
    return {
      requestSent: false,
      email: '',
      breadcrumbs: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Registrazione',
        },
      ],
      activeTab: '1',
    }
  },
  head() {
    return {
      title: 'Registrazione - UniCredit RE Services',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'unicreditres.it',
        },
      ],
    }
  },
  methods: {
    handleLogin() {
      this.$router.push('/area-riservata/dashboard')
    },
    async handleSuccess(data) {
      this.requestSent = true
      this.email = data.email

      await this.$tealium.track({
        event_name: 'registrazione_ok',
        user_email: data.email,
        login_type: 'Sito',
        user_type: data.type === 'v' ? 'Venditore' : 'Compratore',
        optin: 'SINGLE',
      })

      this.$cookies.set('auth._token.laravelSanctum', 'true', {
        domain: this.$config.cookieDomain,
        secure: this.$config.cookieSecure,
        path: '/',
      })

      try {
        await this.$auth.fetchUser()
        await this.$interactions.save()
      } catch (error) {
        // eslint-disable-next-line no-console
        setTimeout(() => {
          this.$router.push('/area-riservata/login')
        }, 5000)
      }
    },
  },
}
</script>
<style lang="postcss">
@import '~/assets/css/components/tabs';
</style>
